import { render } from "./DescriptionEditor.vue?vue&type=template&id=2e9e28c2"
import script from "./DescriptionEditor.vue?vue&type=script&lang=js"
export * from "./DescriptionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__